import { DefaultTheme, Theme, ThemeOutfittery } from "@lookiero/aurora";
import { Tradename } from "@lookiero/sty-sp-tradename";
const THEME = {
    [Tradename.LOOKIERO]: DefaultTheme,
    [Tradename.OUTFITTERY]: ThemeOutfittery,
};
const themeByTradename = ({ tradename }) => THEME[tradename];
const theme = () => Theme.get();
export { theme, themeByTradename };
